let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("llE2X")).then(() => parcelRequire('lHApX'));